import api from '@/api/api'
import { Notification } from 'element-ui'


const state = {
  menuItems: [],
}

const getters = {
  getMenuItems: state => state.menuItems,
}

const mutations = {
  ADD_MENU_ITEM (state, menuItem) {
    state.menuItems.push(menuItem)
  },
  EDIT_MENU_ITEM (state, menuItem) {

  },
  EMPTY_MENU_ITEMS (state) {
    state.menuItems = []
  },
  DELETE_MENU (state, id) {
    for (let item of state.menuItems) {
			if (item.id == id) {        
				let index = state.menuItems.indexOf(item)
				state.menuItems.splice(index, 1)
			}
		}
  }
}

const actions = {
  //  fetching all menu items from service
  async fetchMenuItems ({ commit }) {

    let dist = await api.fetchMenuItems()    
    dist = dist.data.data
    commit('EMPTY_MENU_ITEMS')
    
    dist.forEach(function (elem) { commit('ADD_MENU_ITEM', elem) })
  },

  // post request to create new menu item
  async saveMenu ({ commit }, menu) {

    let response
      await api.saveMenuItems(menu)
      .then((res) => {
        response = res
      })
      .catch((err) => {
        response = err
               
      })
      if (response.status === 201) {

        menu = response.data.data
        Notification.success({
          title: 'Success',
          message: 'Menu successfully added.'
        })
        return {status: 'success', menu: menu}
      } else if (response.data.type == 'validation_error') {
        Notification.error({
          title: 'Error',
          message: 'All required fields need to be filled.'
        })
        return {err: response.data.fields, menu: {menu: menu.menu}}
      } else {
        return {menu: menu}
      }
    
  },

  async updateMenu ({ commit }, menu) {
    let response
    let id = menu.id

    await api.updateMenuItems(id, menu)
    .then((res) => {
      response = res
    })
    .catch((err) => {
      response = err
    })
    if (response.status === 200) {
      menu.id = response.data.data.id

      Notification.success({
        title: 'Success',
        message: 'Menu successfully updated.'
      })
      return {status: 'success', menu: menu}
    } else if (response.status === 422) {
      Notification.error({
        title: 'Error',
        message: 'An error has occured.'
      })
      
      return {err: response.data.fields, menu :menu}
    } else {
      return {menu: menu}
    }
  },

  async deleteMenu ({ commit }, id) {
    let response
    await api.deleteMenuItems(id)
    .then((res) => {
      response = res
    })
    .catch((err) => {
      response = err
    })
    
    if (response.status === 204) {
      Notification.success({
        title: 'Success',
        message: 'Menu successfully deleted.'
      })
      commit('DELETE_MENU', id)
      return true
    } else {
      Notification.error({
        title: 'Error',
        message: 'An error has occured.'
      })
    }
  }
}


export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menuItems.js